<template>
  <div style="margin-bottom:56px;" class="hidden-sm-and-up">
    <div class="mobile_nav_wrap hidden-sm-and-up">
      <div class="navbar_left" @click="gobackHome">
        <img src="../../../assets/img/home/callme/down_logo.png" alt="璟点台球集团" />
      </div>
      <div class="navbar_right">
        <div class="nav_btns" @click="moveMenu">
          <i class="el-icon-menu"></i>
        </div>
      </div>
    </div>
    <!-- 核心修改：给菜单容器加动态class控制固定定位 -->
    <div
        class="nav_menu"
        ref="menu"
        :class="{ 'menu-fixed': menuShow }"
    >
      <!-- 循环渲染一级菜单 -->
      <div v-for="(menu, index) in menuList" :key="index" class="menu_wrapper">
        <!-- 一级菜单 - 路由链接型（如首页、赛事） -->
        <router-link
            v-if="menu.type === 'router'"
            class="menu_item"
            :to="menu.path"
            :class="currentActive === index ? 'active' : ''"
            @click="closeAllSubMenu"
        >
          {{ menu.label }}
        </router-link>

        <!-- 一级菜单 - 下拉型（有二级菜单） -->
        <div
            v-else
            class="menu_item"
            @click="toggleFirstMenu(index)"
            :class="currentActive === index ? 'active' : ''"
        >
          {{ menu.label }}
        </div>

        <!-- 二级菜单区域 -->
        <div class="item_options" v-show="activeFirstIndex === index">
          <div
              v-for="(subMenu, subIndex) in menu.children"
              :key="subIndex"
              class="sub_menu_item"
          >
            <!-- 璟点台球集团二级菜单 - 普通链接 -->
            <a
                :href="subMenu.path"
                class="sub_menu_link"
                @click="closeAllSubMenu"
            >
              {{ subMenu.label }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getBrandList, getProductClassify} from "@/api/home";

export default {
  data() {
    return {
      menuShow: false,
      activeFirstIndex: -1, // 激活的一级菜单索引
      activeSecondIndex: -1, // 激活的二级菜单索引

      // 菜单数据源（整合品牌真实数据）
      menuList: [
        {
          label: '首页',
          type: 'router',
          path: '/home'
        },
        {
          label: '璟点台球集团',
          type: 'dropdown',
          children: [
            { label: '公司简介', path: '/company?flag=com' },
            { label: '董事长简介', path: '/company?flag=chairmans' },
            { label: '公司大事件', path: '/company?flag=majorEvent' }
          ]
        },
        {
          label: '品牌',
          type: 'dropdown',
          children: [],
        },
        {
          label: '赛事',
          type: 'router',
          path: '/contest'
        },
        {
          label: '社交平台',
          type: 'router',
          path: '/social'
        }
      ]
    }
  },
  props: {
    currentActive: {
      default: 0,
      type: Number,
    },
  },
  created () {
    this.getBrandList();
  },
  methods: {
    // 请求品牌子菜单数据
    async getBrandList() {
      try {
        const res = await getBrandList();
        if (res.code === 200) {
          const brandChildren = res.data?.length
              ? res.data.map(item => ({
                label: item.name, // label取原数据的name字段
                path: item.url    // path取原数据的url字段
              })) : [];
          // 找到品牌菜单的索引
          const brandMenuIndex = this.menuList.findIndex(menu => menu.label === '品牌')
          if (brandMenuIndex !== -1) {
            // 替换品牌菜单的children数据
            this.$set(this.menuList, brandMenuIndex, {
              ...this.menuList[brandMenuIndex],
              children: brandChildren
            })
          }
        }
      } catch (error) {
        this.$message?.error("网络异常，请稍后重试");
      }
    },

    // 请求品牌子菜单数据（10列，满足9+列要求）
    async fetchBrandSubmenu() {
      try {
        const res = await getProductClassify();
        // 找到品牌菜单的索引
        const brandMenuIndex = this.menuList.findIndex(menu => menu.label === '品牌')
        if (brandMenuIndex !== -1) {
          // 替换品牌菜单的children数据
          this.$set(this.menuList, brandMenuIndex, {
            ...this.menuList[brandMenuIndex],
            children: res.data
          })
        }
      } catch (err) {
        console.error('品牌子菜单数据请求失败：', err);
      }
    },

    // 展开/收起导航菜单（核心修改：简化定位逻辑，依赖CSS类控制）
    moveMenu() {
      this.menuShow = !this.menuShow
      // 移除手动修改top的逻辑，改为通过CSS类控制固定/隐藏
      if (!this.menuShow) {
        this.activeFirstIndex = -1
        this.activeSecondIndex = -1
      }
    },
    // 切换一级菜单（展开/关闭二级）
    toggleFirstMenu(index) {
      if (this.activeFirstIndex === index) {
        this.activeFirstIndex = -1
        this.activeSecondIndex = -1
      } else {
        this.activeFirstIndex = index
        this.activeSecondIndex = -1
      }
    },
    // 切换二级菜单（展开/关闭三级）
    toggleSecondMenu(firstIndex, secondIndex) {
      if (this.activeSecondIndex === secondIndex && this.activeFirstIndex === firstIndex) {
        this.activeSecondIndex = -1
      } else {
        this.activeSecondIndex = secondIndex
      }
    },
    goToBrandCl(productId) {
      if (!productId || productId <= 0) {
        console.log('productId无效：', productId)
        return
      }
      if(productId == '52'){
        this.$router.push({
          path: '/table'
        })
      }else{
        // 手动跳转，带查询参数
        this.$router.push({
          path: '/brand_cl',
          query: { productId: productId }
        }).catch(err => {
          console.log('品牌页面跳转失败：', err)
        })
      }
      // 核心修复：点击品牌菜单后关闭所有子菜单+隐藏菜单面板
      this.closeAllSubMenu()
    },
    // 关闭所有子菜单（点击路由链接时）- 完善：新增关闭菜单面板逻辑
    closeAllSubMenu() {
      this.activeFirstIndex = -1 // 关闭二级菜单展开状态
      this.activeSecondIndex = -1 // 关闭三级菜单展开状态
      this.menuShow = false // 重置菜单面板显示状态
    },
    // 返回首页
    gobackHome() {
      this.$router.replace('/home')
      this.closeAllSubMenu()
    }
  },
}
</script>

<style lang="scss" scoped>
// 核心修复：给所有元素应用box-sizing，保留原有尺寸
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.mobile_nav_wrap {
  box-sizing: border-box;
  width: 100%;
  height: 56PX;
  background: #fff;
  z-index: 1000;
  display: flex;
  padding: 15PX 0 15PX 15PX;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;

  .navbar_left {
    flex: 1;
    background: #fff;
    img {
      width: 100%;
    }
  }
  .navbar_right {
    flex: 2;
    height: 56PX;
    display: flex;
    justify-content: flex-end;
    background: #fff;
    .nav_btns {
      width: 56PX;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      i{
        font-size: 30PX;
      }
    }
  }
}

.active{
  color: #F39C00 !important;
  font-weight: bold;
}

// 核心修改：重构菜单定位逻辑
.nav_menu{
  // 默认隐藏状态：fixed定位 + 负top值
  position: fixed;
  width: 100%;
  height: auto;
  max-height: calc(100vh - 56px); // 菜单高度不超过视口（减去导航栏高度）
  overflow-y: auto; // 菜单内容超出时可滚动
  list-style: none;
  left: 0;
  right: 0;
  top: -100%; // 默认隐藏（用百分比更适配）
  padding-bottom: 0;
  box-sizing: border-box;
  background: #EFF0F1;
  box-shadow: 0 10PX 20PX rgba(0,0,0,.1);
  z-index: 999; // 低于导航栏但高于页面内容
  transition: top 0.3s ease; // 优化过渡动画

  // 展开时的固定样式
  &.menu-fixed {
    top: 14vw; // 对齐导航栏底部
  }

  .menu_wrapper {
    width: 100%;
  }

  .menu_item{
    width: 100%;
    height: 40PX;
    font-size: 16PX;
    background: #EFF0F1;
    color: #1c212d;
    padding: 30PX;
    display: flex;
    align-items: center;
  }

  // 二级菜单容器
  .item_options{
    width: 100%;
    padding: 5PX 10PX;
    font-size: 14PX;
    background: #fff;

    .sub_menu_item {
      width: 100%;
      height: auto; // 适配品牌二级菜单高度
      min-height: 40PX;
    }

    .sub_menu_link, .sub_menu_toggle {
      display: inline-block;
      width: 100%;
      color: #666;
      height: 100%;
      padding: 20px 30PX;
      cursor: pointer;
      text-decoration: none;
    }

    .sub_menu_toggle {
      color: #F39C00; // 带三级菜单的二级项标为橙色
    }
  }

  // 三级菜单容器
  .third_options {
    width: 100%;
    padding: 5PX 10PX;
    font-size: 14PX;
    background: #f8f8f8;

    .third_menu_link {
      display: inline-block;
      width: 100%;
      color: #666;
      height: 40PX;
      padding: 10PX 45PX;
      line-height: 20PX;
      text-decoration: none;
      cursor: pointer; // 新增：添加鼠标指针样式，提示可点击
    }

    .third_menu_link:hover {
      color: #F39C00;
    }
  }
}

// 补充：给页面主体加padding-top，避免内容被固定导航栏遮挡
::v-deep body {
  padding-top: 56px;
}
</style>